import { apiRoutes } from "../Constant/ApiRoutes";
import { getRequest } from "../apiRequest";
import Avatar from "../images/Avatar.svg";

export const getUsersList = () => {
  return getRequest(apiRoutes.kbUsers);
};
